'use client';

import { useTranslation } from 'react-i18next';

import { Either } from '@sola/schema/dotcom/helpers.js';

import {
  InputField,
  InputFieldProps,
  InputFieldWithAriaLabel,
  InputFieldWithLabel,
  InputFieldWithoutLabel,
} from '../input-field/input-field';

export type EmailFieldProps = Either<
  InputFieldWithLabel,
  Either<InputFieldWithAriaLabel, InputFieldWithoutLabel>
> &
  Omit<
    InputFieldProps,
    'type' | 'inputMode' | 'step' | 'pattern' | 'spellCheck' | 'autoCorrect'
  >;

export const EmailField: React.FC<EmailFieldProps> = ({ ...fieldProps }) => {
  const { t } = useTranslation(['forms']);
  return (
    <InputField
      type="email"
      autoComplete="email"
      autoCapitalize="off"
      pattern={{
        value:
          /^$|^[\w!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,63})$/,
        // value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: t('forms:errors.invalidEmail'),
      }}
      {...fieldProps}
    />
  );
};
